import React, { use, useEffect } from "react";
import ModalComponent from "../../../../core/layouts/main/components/Modal";
import { Tabs } from "react-bootstrap";
import DateScroller from "../../../../core/layouts/main/main-components/dates/DateScroller";
import GoogleMap from "./GoogleMap";
import { DeviceController } from "../../../../core/config/controllers/DeviceController";
import { DateHelper } from "../../../../core/config/helpers/DateHelper";
import TrackerSettings from "./TrackerSettings";
import GoogleMapsRoute from "./GoogleMapRoutes";
import CopyToClipboard from "react-copy-to-clipboard";

export default function VehicleModal({ vehicle, show, onHide }) {
    const [data, setData] = React.useState(vehicle || {});
    const [positions, setPositions] = React.useState([]);
    const [tracker, setTracker] = React.useState({});

    useEffect(() => {
        setData(vehicle || {});
        loadTrackerData();
    }, [vehicle]);

    useEffect(() => {
        loadPositions()
    }, [tracker]);

    function loadTrackerData() {
        if (vehicle && vehicle.id) {
            DeviceController.ListByVehicle(vehicle.id, (res) => {
                console.log("Tracker data loaded:", res);
                setTracker(res[0] || {});
            });
        }
    }

    function loadPositions(today) {
        if (tracker && !tracker.id) return;
        // const today = new Date();
        if (!today) {
            today = new Date();
        }
        const start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
        const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();
        DeviceController.ListDateLocations(tracker.id, start, end, res => {
                let result = res.data.result ?? [];
                console.log("result", res);
                const myPositions = result.filter(x => x.lat_value !== undefined && x.lat_value !== 0 && x.dt_value >= start && x.dt_value <= end) || [];

                myPositions.sort((a, b) => a.dt_value - b.dt_value);

                console.log("result", myPositions);
                let distance = 0;
                for (let i = 1; i < myPositions.length; i++) {
                    const prev = myPositions[i - 1];
                    const curr = myPositions[i];
                    const toRad = deg => deg * Math.PI / 180;
                    const R = 6371; // Earth radius in km
                    const dLat = toRad(curr.lat_value - prev.lat_value);
                    const dLng = toRad(curr.lng_value - prev.lng_value);
                    const lat1 = toRad(prev.lat_value);
                    const lat2 = toRad(curr.lat_value);

                    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
                    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    distance += R * c;
                }

                const maxSpeed = myPositions.reduce((max, pos) => pos.spd_value > max ? pos.spd_value : max, 0);

                setData({
                    ...data,
                    distance: distance.toFixed(2),
                    maxSpeed: maxSpeed,
                });

                console.log("result", myPositions);
                setPositions(myPositions);
        })
    }

    return (
        <ModalComponent
            show={show}
            title={"Veículo"}
            onHide={() => onHide()}>


            <Tabs defaultActiveKey={"details"} id="vehicle-tabs" className="mb-3">
                <Tabs.Tab eventKey="details" title="Detalhes">
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        <DateScroller notifyDate={date => loadPositions(date)} />
                    </div>
                    <GoogleMapsRoute
                        defaultZoom={9}
                        locations={positions}
                        defaultCenter={{
                            lat: -23.57,
                            lng: -46.68,
                        }}
                        bootstrapURLKeys={{
                            key: "AIzaSyDN3UVIMYb0l_DCSkM6DwSnD6Ow3prkWZI",
                            libraries: ["drawing"],
                        }}
                    >
                    </GoogleMapsRoute>
                    <div className="block-content">

                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 600, fontSize: 22, color: '#232323' }}>
                                    {vehicle.manufacturer || 'Fabricante'} - {vehicle.model || 'Modelo'}
                                </div>
                                <div style={{ fontWeight: 600, fontSize: 18, color: '#232323' }}>
                                    <i className="far fa-registered" /> Placa: {vehicle.plate || 'Placa'}
                                </div>
                                <div style={{ fontWeight: 600, fontSize: 18, color: '#232323' }}>
                                    <i className="fa fa-tint" /> Cor: {vehicle.color_name || 'Cor'}
                                </div>
                            </div>
                            <img
                                src={'assets/media/carro.png'}
                                alt="Carro"
                                style={{ width: 140, height: 60, objectFit: 'contain' }}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                            <span style={{ display: 'flex', alignItems: 'center', marginRight: 16, color: '#888', fontWeight: 500 }}>
                                <span style={{ marginRight: 6 }}>
                                    <i className="si si-map" />
                                </span>
                                {data.distance || '0.00'} km
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', color: '#888', fontWeight: 500 }}>
                                <span style={{ marginRight: 6 }}>
                                    <i className="si si-speedometer" />
                                </span>
                                {data.maxSpeed || '0'} km/h
                            </span>
                        </div>

                        <div className="content-heading" style={{ marginTop: 16 }}>
                            Rastreador
                        </div>
                        {tracker && tracker.id ? (
                            <table className="table table-striped table-vcenter">
                                <tbody>
                                    <tr>
                                        <td>Modelo</td>
                                        <td>{tracker && tracker.name}</td>
                                    </tr>
                                    <tr>
                                        <td>Número</td>
                                        <td>{tracker && tracker.sim_number}</td>
                                    </tr>
                                    <tr>
                                        <td>ID Parceiro</td>
                                        <td>{tracker && tracker.smart_gps_id}</td>
                                    </tr>
                                    <tr>
                                        <td>Criado em</td>
                                        <td>{tracker && DateHelper.DateTranslate(tracker.created_at)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        ) :
                            <div className="alert alert-warning">
                                Nenhum rastreador vinculado a este veículo.
                            </div>
                        }

                        <div className="text-center mt-3">
                            <CopyToClipboard
                                text={data && `https://backoffice.rastromais.com/#/shared/?vehicleId=${data.id}`}>
                                <button className="btn btn-primary" onClick={() => loadTrackerData()}>
                                    <i className="far fa-copy" /> Compartilhar veículo
                                </button>
                            </CopyToClipboard>
                        </div>
                    </div>
                </Tabs.Tab>
                <Tabs.Tab eventKey="settings" title="Configurações">
                    <TrackerSettings infos={tracker} />
                </Tabs.Tab>
            </Tabs>

        </ModalComponent>
    )
}